import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams, useHistory } from 'react-router-dom'
import { Panel, Button, Message, Grid, Row, Col, Icon } from 'rsuite'
import BudgetPlan from './budgetPlan/BudgetPlan'
import BudgetSummary from './budgetSummary/BudgetSummary'
import PeriodExpenses from './periodExpenses/PeriodExpenses'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { getSchemaSidebar } from '../../redux/actions/sidebar'
import BudgetInstallmentPlan from './budgetInstallmentPlan/BudgetInstallmentPlan'
import BudgetPlanMuti from './budgetPlan/BudgetPlanMuti'
import { saveChangePayment } from '../../redux/actions/paymentSave'
import WithdrawRequestStatusWidget from '../../widgets/progressReportWidget/withdraw/WithdrawRequestStatusWidget'
import { startLoading, doneLoading } from '../../utils/loading'
import pathname from '../../constants/pathname'
import PlannedDisbursement from './plannedDisbursement/PlannedDisbursement'
import AlertWidget from '../confirm/AlertWidget'
import CancelApprovalList from '../../components/modal/ApproverListModal/CancelApprovalList'
import ApproverList from '../../components/modal/ApproverListModal/ApproverList'
import FetchNewApprover from '../../components/modal/ApproverListModal/FetchNewApprover'
import TotalBudgetWidgets from '../projectProposal/budget/TotalBudgetWidgets'
import ContractChangeExtendPeriodBudget from '../contractChangeExtendPeriod/ContractChangeExtendPeriodBudget'
import ContractChangeExtendPeriodBudgetView from '../contractChangeExtendPeriod/ContractChangeExtendPeriodBudgetView'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import { DEFAULT_ERR_MSG } from '../../constants/msgText'

export default function Budget({
  schema,
  isEditable,
  isHidePeriodExpenses,
  isHideBudgetPlan,
  isHideBudgetInstallmentPlan,
  isCollapseAllTableRow,
  isEditableBudgetPlan,
  isEditableBudgetInstallmentPlan,
  isShowBudgetSubmitButton,
  shouldGetSidebarAfterSaveBudgetPlan,
  projectVersionId,
  isSaveBudgetPlanStep,
  onClickConfirmBudget = () => {},
  confirmForceSchema,
  schemaButton,
  isMulti,
  projectIdList,
  onComplete = () => {},
  onSuccess = () => {},
  isEditWithdrawBudget,

  withdrawRequestStatusSchema,
  isWithdraw,
  requestId,
  shaded = true,
  bordered = true,
}) {
  const dispatch = useDispatch()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()
  const [formSchema, setFormSchema] = useState(schema)
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState()
  const [isShowConfirmBudgetModal, setIsShowConfirmBudgetModal] = useState(false)
  const [isShowConfirmBudgetInstallmentPlanModal, setIsShowConfirmBudgetInstallmentPlanModal] =
    useState(false)
  const [isShowConfirmForce, setIsShowConfirmForce] = useState(false)

  const [currentPeriodExpenses, setCurrentPeriodExpenses] = useState()

  const [currentBudgetPlan, setCurrentBudgetPlan] = useState()
  const [isEditBudgetPlan, setIsEditBudgetPlan] = useState(false)

  const [currentBudgetPlanInstallment, setCurrentBudgetPlanInstallment] = useState()
  const [isEditBudgetInstallmentPlan, setIsEditBudgetInstallmentPlan] = useState(false)

  const [currentTotalInstallment, setCurrentTotalInstallment] = useState()

  const [budgetData, setBudgetData] = useState()
  const [budgetInstallmentPlanData, setBudgetInstallmentPlanData] = useState()

  const [withdrawBudgetData, setWithdrawBudgetData] = useState()
  const [withdrawbudgetInstallmentPlanData, setWithdrawBudgetInstallmentPlanData] = useState()

  const [budgetInstallmentPlanErrorMessage, setBudgetInstallmentPlanErrorMessage] = useState()

  const [msgErrorChecked, setMsgErrorChecked] = useState(null)
  const [isShowModalChecked, setIsShowModalChecked] = useState(false)
  const [errorMessageAgain, setErrorMessageAgain] = useState()

  useEffect(() => {
    // console.log(formSchema)
    if (formSchema) {
      setWithdrawBudgetData(formSchema?.budget?.periodExpensesData)
      setWithdrawBudgetInstallmentPlanData(formSchema?.budgetInstallmentPlan?.installment)
    }
  }, [formSchema])

  const manageBudgetPlan = () => {
    setCurrentBudgetPlan(formSchema.projectBudgetPlan)

    if (!isEditableBudgetPlan) {
      return
    }
    // setIsEditBudgetPlan(
    //   !formSchema.projectBudgetPlan?.masterBudgetPlan?.value ||
    //     !formSchema.projectBudgetPlan?.masterBudgetValue?.value
    // )
    setIsEditBudgetPlan(
      !formSchema?.projectBudgetPlan?.masterBudgetPlan?.value ||
        !formSchema?.projectBudgetPlan?.subBudgetPlan?.value ||
        !formSchema?.projectBudgetPlan?.masterBudgetValue?.value ||
        !formSchema?.projectBudgetPlan?.subBudgetValue?.value
    )

    //multi
    if (formSchema.budget?.periodExpensesData && !isHidePeriodExpenses) {
      const total = formSchema.budget?.periodExpensesData.reduce((sum, cur) => sum + cur.cost, 0)
      setCurrentTotalInstallment(total)
    }
  }

  const manageBudgetInstallmentPlan = () => {
    if (!isEditableBudgetInstallmentPlan) {
      setCurrentBudgetPlanInstallment(formSchema.budgetInstallmentPlan?.installment)
      return
    }

    if (formSchema.budget?.periodExpensesData && !isHidePeriodExpenses) {
      const existInstallment =
        formSchema.budgetInstallmentPlan?.installment?.slice(
          0,
          formSchema.budget?.periodExpensesData.length
        ) || []
      setCurrentBudgetPlanInstallment(existInstallment)
    } else {
      setCurrentBudgetPlanInstallment(formSchema.budgetInstallmentPlan?.installment)
    }

    if (!formSchema.budget?.periodExpensesData?.length) {
      setIsEditBudgetInstallmentPlan(false)
    } else if (
      formSchema.budget?.periodExpensesData?.length !==
      formSchema.budgetInstallmentPlan?.installment?.length
    ) {
      setIsEditBudgetInstallmentPlan(true)
    } else {
      setIsEditBudgetInstallmentPlan(false)
    }
  }

  useEffect(() => {
    setCurrentPeriodExpenses(formSchema.budget?.periodExpensesData)

    manageBudgetPlan()
    manageBudgetInstallmentPlan()
  }, [formSchema])

  const handleOnChangeBudget = (totalInstallment, periodExpenses) => {
    setCurrentPeriodExpenses(periodExpenses)
    setCurrentTotalInstallment(totalInstallment)
    if (periodExpenses?.length) {
      setIsEditBudgetInstallmentPlan(true)
    } else {
      setIsEditBudgetInstallmentPlan(false)
    }

    //multi
    if (isMulti) {
      setIsEditBudgetPlan(true)
    }
  }

  const handleOnCompleteBudgetPlan = (forms) => {
    setCurrentBudgetPlan(forms?.ProjectBudgetPlan)
    setCurrentBudgetPlanInstallment(forms?.budgetInstallmentPlan?.installment)
    setIsEditBudgetInstallmentPlan(true)
  }

  const handleGetSchemaSideBar = async () => {
    if (shouldGetSidebarAfterSaveBudgetPlan) {
      await dispatch(getSchemaSidebar(projectId))
    }
  }

  const handleConfirmBudget = () => {
    //console.log('withdrawBudgetData', withdrawBudgetData)
    //console.log('withdrawbudgetInstallmentPlanData', withdrawbudgetInstallmentPlanData)
    if (isEditWithdrawBudget && isEditBudgetInstallmentPlan) {
      setBudgetInstallmentPlanErrorMessage('กรุณาบันทึกแผน ก่อนยืนยันงบประมาณ')
      return
    }
    setIsShowConfirmBudgetModal(true)
  }

  const handleCallApiChangePayment = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage('')
    try {
      const response = await saveChangePayment(request, request.projectVersionId)
      console.log('response', response)

      if (response.success) {
        setIsLoading(false)
        doneLoading()
        // return history.push(`${pathname.proposal.overview.overviewCoworker}/${projectId}`)
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      } else if (response?.model?.info?.length > 0) {
        let msg = ''
        response?.model?.info.map((item, index) => {
          msg += `${index + 1}). ${item.checkCategoryCostMessage} <br />`
        })

        setErrorMessage(response?.errorMessage)
        setMsgErrorChecked(msg)
        setIsShowModalChecked(true)
      }
    } catch (e) {
      console.log(e)
      setErrorMessage(DEFAULT_ERR_MSG)
    }
    setIsLoading(false)
    doneLoading()
  }

  //multi
  const handleCallApiSave = async (request) => {
    startLoading()
    setIsError(false)
    try {
      const _schema = await savePaymentMulti(request)
      onComplete()
    } catch (e) {
      setIsError(true)
    }
    doneLoading()
  }

  const handleSaveBudgetInstallmentPlan = async (request) => {
    startLoading()
    setIsError(false)
    try {
      const _schema = await savePaymentMulti(request)
      onComplete()
    } catch (e) {
      setIsError(true)
    }
    doneLoading()
  }

  const handleOnConfirmBudgetInstallmentPlan = () => {
    setIsShowConfirmBudgetInstallmentPlanModal(false)
    if (isMulti) {
      const request = {
        projectVersionIds: projectIdList,
        budgetInstallmentPlans: budgetInstallmentPlanData,
      }

      handleSaveBudgetInstallmentPlan(request)
    }
  }

  const handleOnConfirmBudgetModal = () => {
    setIsShowConfirmBudgetModal(false)

    console.log('isEditWithdrawBudget ', isEditWithdrawBudget)

    if (isMulti) {
      let categoryOfCost = []

      budgetData.forEach((item, index) => {
        if (index < budgetData.length - 1) {
          let categoryCost = item.children.map((subitem, index) => {
            if (index < item.children.length - 1) {
              return {
                categoryCostId: subitem.id,
                cost: subitem.cost,
                vat: subitem.vat,
              }
            }
          })

          let detail = item.children[item.children?.length - 1]?.children[0]?.list

          let installment = {
            categoryOfCostId: item.id,
            numberOfInstallment: item.numberOfInstallment,
            deliveryDate: item.date,
            budgetYear: item.year,
            detail: detail,
            categoryCost: categoryCost.filter((e) => {
              return e != null
            }),
          }

          categoryOfCost.push(installment)
        }
      })

      const request = {
        projectVersionIds: projectIdList,
        categoryOfCost: categoryOfCost,
      }

      handleCallApiSave(request)
    } else if (isEditWithdrawBudget) {
      let periodExpensesData = withdrawBudgetData.filter((item) => !item.isTotal)
      //console.log('periodExpensesData', periodExpensesData)
      let _periodExpensesData = periodExpensesData.map((item, index) => {
        var isDisabled = item.disabled

        if (isDisabled && formSchema?.extendPreiod?.periods) {
          const match = item.list.match(/\d+/)
          const period = match ? parseInt(match[0], 10) : 0
          //console.log('list : ', item.list, ' , period :', period)

          var changePreiod = formSchema.extendPreiod?.periods?.find((e) => e.period == period)
          //console.log('changePreiod : ', changePreiod)

          if (changePreiod?.isChange) {
            isDisabled = false
          }
        }

        let data = {
          id: item.id,
          cost: item.cost,
          date: item.date,
          year: item.year,
          startDate: item.startDate,
          endDate: item.endDate,
          disabled: isDisabled,
          children: item?.children?.map((_item) => {
            let _data = {
              id: _item.id,
              cost: _item.cost,
              vat: _item.vat || 0,
            }
            return _data
          }),
        }
        return data
      })

      //console.log('_periodExpensesData', _periodExpensesData)

      let pId = formSchema?.extendPreiod?.projectVersionId || projectVersionId || projectId

      const request = {
        projectVersionId: pId,
        periodExpensesData: _periodExpensesData,
        budgetInstallmentPlan: withdrawbudgetInstallmentPlanData,
      }

      handleCallApiChangePayment(request)
    } else {
      onClickConfirmBudget(setIsLoading, setErrorMessage, setIsShowConfirmForce)
    }
  }

  const handleOnConfirmBudgetInstallmentPlanModal = () => {
    setIsShowConfirmBudgetInstallmentPlanModal(false)

    if (isMulti) {
    }
  }

  const handleSaveBuget = (data) => {
    setBudgetData(data)
    setIsShowConfirmBudgetModal(true)
  }

  const onSubmitBudgetInstallmentPlan = (data) => {
    setBudgetInstallmentPlanData(data)
    setIsShowConfirmBudgetInstallmentPlanModal(true)
  }
  // const handleOnChangeBudget = (totalInstallment) => {
  //   setCurrentTotalInstallment(totalInstallment)
  //   setIsEditBudgetPlan(true)
  // }

  const handleOnChangeWithdrawBudget = (budgetTableData) => {
    //console.log('budgetTableData', budgetTableData)
    setWithdrawBudgetData(budgetTableData)
  }

  const handleOnSaveInstallmentPlan = (installmentPlan) => {
    //console.log('installmentPlan', installmentPlan)
    setWithdrawBudgetInstallmentPlanData(installmentPlan)
  }

  const handleOnConfirmForce = () => {
    setIsShowConfirmForce(false)
    let forceCommit = true
    onClickConfirmBudget(setIsLoading, setErrorMessage, setIsShowConfirmForce, forceCommit)
  }

  return (
    <>
      <Panel
        header={formSchema.header}
        shaded={shaded}
        bordered={bordered}
        collapsible
        defaultExpanded
      >
        {!isMulti && (
          <div style={{ marginBottom: 10 }}>
            <BudgetSummary
              header={formSchema.budget?.budgetSummaryHeader}
              budget={formSchema.budget?.budgetSummary}
              duration={formSchema.budget?.duration}
              withdrawn={formSchema.budget?.withdrawn}
              balance={formSchema.budget?.balance}
            />

            {formSchema.budgetCategory && (
              <div style={{ marginTop: 10 }}>
                <TotalBudgetWidgets schema={formSchema.budgetCategory} shaded={false} />
              </div>
            )}

            {formSchema.extendPreiod && (
              <div style={{ marginTop: 10 }}>
                <ContractChangeExtendPeriodBudgetView
                  header={formSchema.extendPreiod.header}
                  data={formSchema.extendPreiod.periods}
                  isBudget={formSchema.extendPreiod.isBudget}
                  shaded={false}
                />
              </div>
            )}
          </div>
        )}

        {!isHideBudgetPlan && (
          <div style={{ marginBottom: 10 }}>
            {isMulti ? (
              <BudgetPlanMuti
                header={formSchema.projectBudgetPlan?.header}
                isEditable={true}
                masterBudgetPlan={formSchema.projectBudgetPlan?.masterBudgetPlan}
                masterBudgetValue={formSchema.projectBudgetPlan?.masterBudgetValue}
                skipReserveEbudget={formSchema.projectBudgetPlan?.skipReserveEbudget}
                subBudgetPlan={formSchema.projectBudgetPlan?.subBudgetPlan}
                subBudgetValue={formSchema.projectBudgetPlan?.subBudgetValue}
                onComplete={handleOnCompleteBudgetPlan}
                projectIdList={projectIdList}
                isEdit={isEditBudgetPlan}
                limitBudgetValue={currentTotalInstallment || formSchema.budget?.budgetSummary}
                isEditCancle={true}
                isSaveBudgetPlanStep={isSaveBudgetPlanStep}
              />
            ) : (
              <BudgetPlan
                header={formSchema.projectBudgetPlan?.header}
                masterBudgetPlan={formSchema.projectBudgetPlan?.masterBudgetPlan}
                masterBudgetValue={formSchema.projectBudgetPlan?.masterBudgetValue}
                subBudgetPlan={formSchema.projectBudgetPlan?.subBudgetPlan}
                subBudgetValue={formSchema.projectBudgetPlan?.subBudgetValue}
                skipReserveEbudget={formSchema.projectBudgetPlan?.skipReserveEbudget}
                isEditable={isEditableBudgetPlan}
                isEdit={isEditBudgetPlan}
                setIsEdit={(_isEdit) => setIsEditBudgetPlan(_isEdit)}
                limitBudgetValue={formSchema.budget?.budgetSummary}
                isSaveBudgetPlanStep={isSaveBudgetPlanStep}
                onComplete={(newSchema) => {
                  handleOnCompleteBudgetPlan(newSchema)
                  handleGetSchemaSideBar()
                }}
                projectVersionId={projectVersionId}
              />
            )}
          </div>
        )}

        {withdrawRequestStatusSchema?.forms?.withdrawRequestStatus && (
          <>
            <WithdrawRequestStatusWidget
              showCommandButton={true}
              schema={withdrawRequestStatusSchema.forms.withdrawRequestStatus}
              header={'สถานะการขอเบิกงวดเงิน'}
              isSubpanel={true}
            />
            <br />
          </>
        )}

        {!isHidePeriodExpenses && (
          <div style={{ marginBottom: 10 }}>
            <PeriodExpenses
              header={formSchema.budget?.periodExpensesHeader}
              data={formSchema.budget?.periodExpensesData}
              initialInstallment={formSchema.masterCategoryOfCost}
              initialData={formSchema.masterCategoryCost}
              startProjectDate={formSchema.budget?.startProjectDate}
              endProjectDate={formSchema.budget?.endProjectDate}
              isEditable={isEditable}
              isCollapseAllTableRow={isCollapseAllTableRow}
              projectVersionId={projectVersionId}
              onChangeBudget={handleOnChangeBudget}
              isMulti={isMulti}
              onMultiSave={isMulti && handleSaveBuget}
              isAssociate={formSchema.isAssociate}
              isEditWithdrawBudget={isEditWithdrawBudget}
              onChangeWithdrawBudget={handleOnChangeWithdrawBudget}
              isWithdraw={isWithdraw}
              requestId={requestId}
              extendPreiod={formSchema.extendPreiod?.periods}
            />
          </div>
        )}

        {formSchema.isAssociate
          ? false
          : true &&
            !isHideBudgetInstallmentPlan &&
            formSchema.budgetInstallmentPlan && (
              <div style={{ marginBottom: 10 }}>
                {/* {console.log(
                  'formSchema.budgetInstallmentPlan?.masterBudgetPlan.label : ',
                  formSchema.budgetInstallmentPlan?.masterBudgetPlan.label
                )} */}
                <BudgetInstallmentPlan
                  header={formSchema.projectBudgetPlan?.header}
                  masterBudgetPlanLabel={formSchema.budgetInstallmentPlan?.masterBudgetPlan.label}
                  masterBudgetPlanItems={formSchema.budgetInstallmentPlan?.masterBudgetPlan.items}
                  subBudgetPlanLabel={formSchema.budgetInstallmentPlan?.subBudgetPlan.label}
                  subBudgetPlanItems={formSchema.budgetInstallmentPlan?.subBudgetPlan.items}
                  isEditable={isEditableBudgetInstallmentPlan}
                  isEdit={isEditBudgetInstallmentPlan}
                  setIsEdit={(_isEdit) => {
                    ;(setIsEditBudgetInstallmentPlan(_isEdit),
                      setBudgetInstallmentPlanErrorMessage(false))
                  }}
                  installment={currentBudgetPlanInstallment}
                  setInstallment={(_installment) => setCurrentBudgetPlanInstallment(_installment)}
                  periodExpenses={currentPeriodExpenses}
                  budgetPlan={currentBudgetPlan}
                  onComplete={() => {
                    if (!isMulti) {
                      handleGetSchemaSideBar()
                    }
                  }}
                  projectVersionId={projectVersionId}
                  isMulti={isMulti}
                  onMultiSave={isMulti && onSubmitBudgetInstallmentPlan}
                  isEditWithdrawBudget={isEditWithdrawBudget}
                  onSaveInstallmentPlan={handleOnSaveInstallmentPlan}
                  errorMessage={budgetInstallmentPlanErrorMessage}
                />
              </div>
            )}

        {formSchema.plannedDisbursement && (
          <div>
            <PlannedDisbursement
              schema={formSchema.plannedDisbursement}
              isWithdraw={isWithdraw}
              isEditable={isEditable}
              isCollapseAllTableRow={isCollapseAllTableRow}
              initialData={formSchema.masterCategoryCost}
              startProjectDate={formSchema?.plannedDisbursement?.startProjectDate}
              endProjectDate={formSchema?.plannedDisbursement?.endProjectDate}
              isAssociate={formSchema.isAssociate}
              onChangeWithdrawBudget={handleOnChangeWithdrawBudget}
              requestId={requestId}
              onComplete={onComplete}
            />
          </div>
        )}

        <Grid fluid>
          <Row>
            {!!formSchema.budget.alert && (
              <Col style={{ marginTop: 20, marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <Message showIcon type="warning" description={formSchema.budget.alert} />
              </Col>
            )}
            {!!errorMessage && (
              <Col style={{ marginTop: 10 }} xs={24} sm={24} md={24} lg={24}>
                <Message showIcon type="error" description={errorMessage} />
              </Col>
            )}

            {isShowBudgetSubmitButton && (
              <Col style={{ marginTop: 20, marginBottom: 20 }} xs={24} sm={24} md={24} lg={24}>
                <SaveButton
                  icon="check-circle"
                  disabled={isLoading || formSchema.budget.isDisabled}
                  children={formSchema.budget?.buttionPeriodExpensesLabel}
                  onClick={handleConfirmBudget}
                />
              </Col>
            )}
            {schemaButton?.checkButton && (
              <ApproverList
                approveType={4}
                projectversionId={projectId}
                style={{ marginRight: 10 }}
                buttontext={schemaButton?.checkButton}
                isLoading={isLoading}
                fetchButton={(disabled) =>
                  schemaButton?.fetchButton && (
                    <FetchNewApprover
                      approveType={4}
                      projectversionId={projectId}
                      style={{ marginRight: 10, marginBottom: 10 }}
                      buttontext={schema?.fetchButton}
                      onSuccess={onSuccess}
                      requestId={schemaButton?.requestNote?.requestId}
                      disabled={disabled}
                    />
                  )
                }
              />
            )}

            {schemaButton?.cancelButton && (
              <CancelApprovalList
                approveType={4}
                projectversionId={projectId}
                style={{ marginRight: 10 }}
                buttontext={schema?.cancelButton}
                requestId={schemaButton?.requestNote?.requestId}
                onSuccess={onSuccess}
              />
            )}
          </Row>
        </Grid>
      </Panel>
      <ConfirmWidget
        title={formSchema.budget?.buttionPeriodExpensesLabel}
        show={isShowConfirmBudgetModal}
        detail={
          isMulti
            ? `ยืนยันบันทึกงบประมาณไปยังทุกโครงการ`
            : `กรุณายืน` + formSchema.budget?.buttionPeriodExpensesLabel
        }
        onCancle={() => setIsShowConfirmBudgetModal(false)}
        onConfirm={handleOnConfirmBudgetModal}
      />

      <ConfirmWidget
        title={'ยืนยันแผนงบประมาณ'}
        show={isShowConfirmBudgetInstallmentPlanModal}
        detail={isMulti ? `ยืนยันบันทึกแผนงบประมาณไปยังทุกโครงการ` : `กรุณายืนยันแผนงบประมาณ`}
        onCancle={() => setIsShowConfirmBudgetInstallmentPlanModal(false)}
        onConfirm={handleOnConfirmBudgetInstallmentPlan}
      />

      {confirmForceSchema && (
        <ConfirmWidget
          title={confirmForceSchema?.header || 'มีบางแผนเงินเป้าเบิกจ่ายคงเหลือไม่เพียงพอ'}
          show={isShowConfirmForce}
          detail={confirmForceSchema.message}
          confirmBtn={confirmForceSchema.button}
          onCancle={() => setIsShowConfirmForce(false)}
          onConfirm={handleOnConfirmForce}
          size="sm"
        />
      )}

      <AlertWidget
        size="sm"
        title={'ข้อความแจ้งเตือน !'}
        show={isShowModalChecked}
        detail={
          <div
            dangerouslySetInnerHTML={{
              __html: msgErrorChecked || '',
            }}
            style={{ padding: 10 }}
          />
        }
        onClose={() => {
          setIsShowModalChecked(false)
          //            location.reload()
        }}
      />
    </>
  )
}
